import React from 'react';
import quote from '../../../assets/icons/quote.svg'
import people1 from '../../../assets/images/people1.png'
import people2 from '../../../assets/images/people2.png'
import people3 from '../../../assets/images/people3.png'

const Testiminial = () => {
    return (
        <section className='mt-16 mb-8'>
            <div className='flex justify-between p-4'>
                <div>
                    <h2 className='text-2xl font-bold text-primary'>Testimonial</h2>
                    <h3 className='text-4xl'>What our patients Says</h3>
                </div>
                <div>
                    <img className='lg:w-48 w-24' src={quote} alt="" />
                </div>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-12'>
                <div className="card shadow-xl">
                    <div className="card-body">
                        <p>It is a long established fact that by the readable content of a lot layout. The point of using Lorem a more-or-less normal distribu to using Content here, content</p>
                        <div className="flex items-center mt-6">
                            <div className="avatar mr-6">
                                <div className="w-16 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                                    <img src={people1} alt="" />
                                </div>
                            </div>
                            <div>
                                <h5 className="text-lg">Winson Herry</h5>
                                <p>California</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card shadow-xl">
                    <div className="card-body">
                        <p>It is a long established fact that by the readable content of a lot layout. The point of using Lorem a more-or-less normal distribu to using Content here, content</p>
                        <div className="flex items-center mt-6">
                            <div className="avatar mr-6">
                                <div className="w-16 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                                    <img src={people2} alt="" />
                                </div>
                            </div>
                            <div>
                                <h5 className="text-lg">Winson Herry</h5>
                                <p>California</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card shadow-xl">
                    <div className="card-body">
                        <p>It is a long established fact that by the readable content of a lot layout. The point of using Lorem a more-or-less normal distribu to using Content here, content</p>
                        <div className="flex items-center mt-6">
                            <div className="avatar mr-6">
                                <div className="w-16 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                                    <img src={people3} alt="" />
                                </div>
                            </div>
                            <div>
                                <h5 className="text-lg">Winson Herry</h5>
                                <p>California</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testiminial;